function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import { isFunction } from "services/utils-service";
import { preventFocusOnMouseDown } from "client/services/accessibility/accessibility-service";
import { StyledBottomCenterPoints } from "./bottom-center-points.scss";
class BottomCenterPoints extends PureComponent {
    render() {
        let self = this;
        const { slideCount, slidesToScroll, currentSlide } = this.props;
        let indexes = this.getIndexes(slideCount, slidesToScroll);
        return /*#__PURE__*/ _jsx(StyledBottomCenterPoints, {
            style: this.getListStyles(),
            children: indexes.map((index)=>{
                return /*#__PURE__*/ _jsx("li", {
                    style: self.getListItemStyles(),
                    children: /*#__PURE__*/ _jsx("button", {
                        tabIndex: 0,
                        className: "bottom-center-point-button",
                        style: self.getButtonStyles(currentSlide === index),
                        onClick: ()=>this.onDotClick(index),
                        onMouseDown: preventFocusOnMouseDown,
                        children: "•"
                    })
                }, index);
            })
        });
    }
    getIndexes(count, inc) {
        let arr = [];
        for(let i = 0; i < count; i += inc){
            arr.push(i);
        }
        return arr;
    }
    getListStyles() {
        return {
            position: "relative",
            margin: 0,
            top: -10,
            padding: 0,
            width: "100vw",
            display: "flex",
            justifyContent: "center"
        };
    }
    getListItemStyles() {
        return {
            listStyleType: "none",
            display: "inline-block"
        };
    }
    getButtonStyles(active) {
        return {
            border: 0,
            background: "transparent",
            cursor: "pointer",
            padding: 10,
            outline: 0,
            fontSize: 24,
            opacity: active ? 1 : 0.5
        };
    }
    constructor(props){
        super(props);
        _define_property(this, "onDotClick", (index)=>{
            const { goToSlide, bottomCenterExtraProps } = this.props;
            const { onButtonClick } = bottomCenterExtraProps;
            if (isFunction(onButtonClick)) {
                onButtonClick(index);
            }
            goToSlide(index);
        });
        this.getIndexes = this.getIndexes.bind(this);
        this.getListStyles = this.getListStyles.bind(this);
        this.getListItemStyles = this.getListItemStyles.bind(this);
        this.getButtonStyles = this.getButtonStyles.bind(this);
    }
}
export { BottomCenterPoints as default };
BottomCenterPoints.defaultProps = {
    bottomCenterExtraProps: {}
};
